import TableCell from "@mui/material/TableCell";
import { formatCurrency } from "@poseidon/utils/currency";
import React from "react";

export const CurrencyCell = ({ value, floor }) => (
  <TableCell
    sx={{
      color: value > 0 ? "success.dark" : value < 0 ? "error.dark" : "",
    }}
  >
    {formatCurrency(value, floor)}
  </TableCell>
);
